export enum FopLoginMode {
    FopLogin = 'FopLogin',
    UserLogin = 'UserLogin'
}

export interface IFopConfig {
    fopModeEnabled: boolean;
    loginMode: FopLoginMode;
    username: string;
    password: string;
    serverWatchdogEnabled: boolean;
    keycloakWatchdogEnabled: boolean;
}

export interface IFopTokens {
    accessToken: string;
    refreshToken: string;
    idToken: string;
}
